import { Controller, Get } from '@nestjs/common';
import { ApiOperation, ApiTags } from '@nestjs/swagger';
import { ConfigEntity } from '@ip6m/server/data-access-config';
import { ConfigurationService } from './services/configuration.service';

@ApiTags('configuration management')
@Controller('v1/configuration')
export class ConfigurationController {

    constructor(private cS: ConfigurationService) {}

    @Get('')
    @ApiOperation({ summary: 'Get system configuration record'})
    getConfiguration(): Promise<ConfigEntity> {
        return this.cS.getConfiguration;
    }

    
}
